<template>
  <div v-if="hasErros">
    <div class="alert alert-danger" role="alert">
      <div v-for="ms in modelstate" :key="ms">
        <span> - {{ ms[0] }} </span>
      </div>
    </div>
    <!-- {{ modelstate }} -->
  </div>
</template>

<script>
export default {
  name: "BaseErrorContainer",
  props: {
    modelstate: Object,
  },
  computed: {
    hasErros() {
      if (!this.modelstate) return false;
      if (this.modelstate.length == 0) return false;

      let count = 0;
      for (let variable in this.modelstate) {
        count++;
      }
      if (count == 0) return false;

      return true;
    },
  },
};
</script>